import { RequestService } from '../../../../../common/services/RequestService';
import { DRIVE_UNIT_TYPES_GET } from '../../constants';

export const getDriveUnitTypesRequest = payload => {
  return RequestService.get(DRIVE_UNIT_TYPES_GET);
};
